import type { MaybeRefOrGetter } from 'vue';

import type { ServerFetchError } from '~/utils/throwOnServerFetchError';

import { useIaChrome } from '~/composables/unified/useIaChrome';

/**
 * What a page does when the record it shows could not be looked up: the fetch failed, or nothing
 * has that slug. On its public route that is the app's error page, the real 404 or 500 a visitor
 * and a crawler get. Inside the coach shell the error page would replace the whole app, the chat
 * and an unsent draft with it, so the failure stays in the subpage: `failed` is true and the page
 * renders `CoachSubpageNotFound` in place of its content.
 */
export const usePageLookupFailure = (error: MaybeRefOrGetter<ServerFetchError | null | undefined>) => {
  const inShell = useIaChrome();

  if (!inShell) {
    watchEffect(() => {
      const failure = toValue(error);
      if (failure) {
        showError({ statusCode: failure.statusCode, statusMessage: failure.message });
      }
    });
  }

  return { failed: computed(() => inShell && Boolean(toValue(error))) };
};
